// frontend/features/mpc-common/src/features/Bidding/SupplierQuoteDrawer/Table.tsx
import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { useMemoizedFn } from 'ahooks';
import { Message } from '@bedrock/components';
import { ProTablePlusForm } from '@mpc/common/src/components';
import { buildColumns, RowOperationCallbacks } from './handleColumns';
import type { BiddingSupplierQuoteTab, ViewMode } from './types';
import { BiddingQuoteTemplateColumnVo } from '#services/api';

interface Props {
  readOnly?: boolean;
  onChange: (rows: any[]) => void;
  onBatchEditChange?: (data: any[]) => void;
  rowOps?: RowOperationCallbacks;
  showInsertOperation?: boolean;
  showCopyOperation?: boolean;
  /** 可编辑的列 */
  canEditColumnCategories?: number[];
  /** 供应商侧（outer）编辑态：尊重列级 outsource_modify 字段控制可编辑性 */
  respectOutsourceModify?: boolean;
  summary?: React.ReactNode;
  value: any[];
  schemaColumns: BiddingQuoteTemplateColumnVo[];
  viewMode: string;
}

export interface BiddingTableRef {
  validateFields: () => Promise<any>;
  validateFieldsAndScroll: () => Promise<any>;
  getValue: () => any[];
  scrollTo: (params: { key: string; dataIndex: string }) => void;
}

const BiddingSupplierQuoteTable = forwardRef<BiddingTableRef, Props>(
  (
    {
      readOnly,
      onChange,
      onBatchEditChange,
      rowOps,
      showCopyOperation = true,
      showInsertOperation = true,
      canEditColumnCategories = [],
      respectOutsourceModify,
      schemaColumns,
      viewMode,
      value,
      ...rest
    },
    ref
  ) => {
    const tableRef = useRef<any>(null);

    const columns = useMemo(
      () =>
        buildColumns({
          schemaColumns,
          readOnly,
          rowOps,
          showCopyOperation,
          showInsertOperation,
          canEditColumnCategories,
          respectOutsourceModify,
          viewMode,
        }),
      [
        schemaColumns,
        readOnly,
        rowOps,
        showInsertOperation,
        showCopyOperation,
        canEditColumnCategories,
        respectOutsourceModify,
        viewMode,
      ]
    );

    useImperativeHandle(ref, () => {
      return {
        ...tableRef.current,
      };
    });

    const handleBatchEditChange = useMemoizedFn((data: any[]) => {
      onBatchEditChange?.(data);
    });

    const onDataChange = (newData, changeData) => {
      onChange?.(newData);
    };

    // if (!tab.rows.length) {
    //   return (
    //     <div className="flex items-center justify-center h-40 text-color-3">
    //       暂无报价明细
    //     </div>
    //   );
    // }

    return (
      <ProTablePlusForm
        ref={tableRef}
        {...rest}
        rowKey={'__table_row_key__'}
        readOnly={readOnly}
        value={value}
        columns={columns}
        onDataChange={onDataChange}
        onBatchEditChange={handleBatchEditChange}
        scroll={{ x: 'max-content', y: 'calc(100vh - 280px)' }}
        verticalBorder
      />
    );
  }
);

export default BiddingSupplierQuoteTable;
